"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakingRewardsData = void 0;
var abi_1 = require("@ethersproject/abi");
var multicall_1 = require("@indexed-finance/multicall");
var bmath_1 = require("../bmath");
var rewardsABI = require('../abi/StakingRewards.json');
var erc20ABI = require('../abi/IERC20.json');
var factoryABI = require('../abi/StakingRewardsFactory.json');
function getStakingRewardsData(provider, pool, factoryAddress, userAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var iface, multi, calls, response, rewardsDuration, periodFinish, rewardRate, lastUpdateTime, totalSupply, poolRewardsBalance, stakingRewardsGenesis, timestamp, isReady, active, hasBegun, claimedRewards, periodStart, rewardPerToken, update;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    iface = new abi_1.Interface(rewardsABI);
                    multi = new multicall_1.MultiCall(provider);
                    calls = [];
                    calls.push({ interface: iface, target: pool.address, function: 'rewardsDuration' });
                    calls.push({ interface: iface, target: pool.address, function: 'periodFinish' });
                    calls.push({ interface: iface, target: pool.address, function: 'rewardRate' });
                    calls.push({ interface: iface, target: pool.address, function: 'lastUpdateTime' });
                    calls.push({ interface: iface, target: pool.address, function: 'totalSupply' });
                    calls.push({ interface: erc20ABI, target: pool.stakingToken, function: 'balanceOf', args: [pool.address] });
                    calls.push({ interface: factoryABI, target: factoryAddress, function: 'stakingRewardsGenesis' });
                    calls.push({ interface: iface, target: pool.address, function: 'rewardPerToken' });
                    if (userAddress) {
                        calls.push({ interface: iface, target: pool.address, function: 'balanceOf', args: [userAddress] });
                        calls.push({ interface: iface, target: pool.address, function: 'earned', args: [userAddress] });
                        calls.push({ interface: erc20ABI, target: pool.stakingToken, function: 'balanceOf', args: [userAddress] });
                        calls.push({ interface: erc20ABI, target: pool.stakingToken, function: 'allowance', args: [userAddress, pool.address] });
                    }
                    return [4 /*yield*/, multi.multiCall(calls)];
                case 1:
                    response = _a.sent();
                    rewardsDuration = bmath_1.bnum(response[0]).toNumber();
                    periodFinish = bmath_1.bnum(response[1]).toNumber();
                    rewardRate = bmath_1.bnum(response[2]);
                    lastUpdateTime = bmath_1.bnum(response[3]).toNumber();
                    totalSupply = bmath_1.bnum(response[4]);
                    poolRewardsBalance = bmath_1.bnum(response[5]);
                    stakingRewardsGenesis = bmath_1.bnum(response[6]).toNumber();
                    timestamp = new Date().getTime() / 1000;
                    isReady = timestamp >= stakingRewardsGenesis;
                    active = periodFinish > 0 && lastUpdateTime < periodFinish;
                    hasBegun = periodFinish > 0;
                    claimedRewards = hasBegun ? pool.totalRewards.minus(poolRewardsBalance) : bmath_1.bnum(0);
                    periodStart = hasBegun ? periodFinish - rewardsDuration : 0;
                    rewardPerToken = bmath_1.bnum(response[7]);
                    update = {
                        active: active,
                        isReady: isReady,
                        hasBegun: hasBegun,
                        rewardsDuration: rewardsDuration,
                        periodStart: periodStart,
                        periodFinish: periodFinish,
                        lastUpdateTime: lastUpdateTime,
                        totalSupply: totalSupply,
                        claimedRewards: claimedRewards,
                        rewardRate: rewardRate,
                        rewardPerToken: rewardPerToken
                    };
                    if (userAddress) {
                        update.userBalanceRewards = bmath_1.bnum(response[8]);
                        update.userEarnedRewards = bmath_1.bnum(response[9]);
                        update.userBalanceStakingToken = bmath_1.bnum(response[10]);
                        update.userAllowanceStakingToken = bmath_1.bnum(response[11]);
                    }
                    return [2 /*return*/, update];
            }
        });
    });
}
exports.getStakingRewardsData = getStakingRewardsData;
